export const SegmentIcon = ({selected}) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.33337 16.6666V3.33331H5.00004V16.6666H3.33337ZM9.16671 16.6666V13.3333H10.8334V16.6666H9.16671ZM15 16.6666V3.33331H16.6667V16.6666H15ZM9.16671 11.6666V8.33331H10.8334V11.6666H9.16671ZM9.16671 6.66665V3.33331H10.8334V6.66665H9.16671Z" fill={ selected ? "white" : "rgba(255, 255, 255, 0.7)" }/>
        </svg>
    )
}
